// This file is auto-generated. Do not edit manually.

export type CSSVariableName =
  | 'color-accent-act'
  | 'color-accent-alt-opacity-0'
  | 'color-accent-alt-opacity-08'
  | 'color-accent-alt-opacity-10'
  | 'color-accent-alt-opacity-12'
  | 'color-accent-alt-opacity-16'
  | 'color-accent-alt-opacity-20'
  | 'color-accent-alt'
  | 'color-accent-opacity-0'
  | 'color-accent-opacity-02'
  | 'color-accent-opacity-16'
  | 'color-accent-opacity-20'
  | 'color-accent-opacity-40'
  | 'color-accent-opacity-80'
  | 'color-accent-splash'
  | 'color-accent'
  | 'color-background-modal'
  | 'color-black-body-0'
  | 'color-black-body-opacity-08'
  | 'color-black-body-opacity-25'
  | 'color-black-body'
  | 'color-black-default'
  | 'color-black-modal-opacity-08'
  | 'color-black-modal-opacity-09'
  | 'color-black-modal-opacity-60'
  | 'color-black-modal'
  | 'color-danger-opacity-0'
  | 'color-danger-opacity-05'
  | 'color-danger-opacity-10'
  | 'color-danger'
  | 'color-grey-dark-opacity-10'
  | 'color-grey-dark-opacity-40'
  | 'color-grey-dark-opacity-50'
  | 'color-grey-dark-opacity-60'
  | 'color-grey-dark'
  | 'color-grey-field-opacity-40'
  | 'color-grey-field-opacity-50'
  | 'color-grey-field'
  | 'color-grey-light-opacity-01'
  | 'color-grey-light-opacity-16'
  | 'color-grey-light-opacity-40'
  | 'color-grey-light-opacity-80'
  | 'color-grey-light'
  | 'color-other-preview'
  | 'color-success-opacity-0'
  | 'color-success-opacity-05'
  | 'color-success-opacity-10'
  | 'color-success-opacity-20'
  | 'color-success'
  | 'color-white'
  | 'gradient-accent-alt'
  | 'gradient-accent'
  | 'gradient-active-badge'
  | 'gradient-active-preview'
  | 'gradient-button-alternative'
  | 'gradient-button-base'
  | 'gradient-button-destructive'
  | 'gradient-button-primary'
  | 'gradient-button-success'
  | 'gradient-danger'
  | 'gradient-dark'
  | 'gradient-input-accent'
  | 'gradient-input-base'
  | 'gradient-input-danger'
  | 'gradient-input-success'
  | 'gradient-loading-overlay'
  | 'gradient-overlay-badge'
  | 'gradient-overlay-card'
  | 'gradient-overlay-preview'
  | 'gradient-section-active'
  | 'gradient-section-waiting'
  | 'gradient-sticky-splitter'
  | 'gradient-success'
  | 'gradient-unread-badge'
  | 'gradient-unread-preview'
  | 'gradient-waiting-badge'
  | 'gradient-waiting-preview'
  | 'module-10'
  | 'module-11'
  | 'module-12'
  | 'module-13'
  | 'module-14'
  | 'module-18'
  | 'module-2'
  | 'module-3'
  | 'module-4'
  | 'module-5'
  | 'module-6'
  | 'module-7'
  | 'module-8'
  | 'module-9'
  | 'module-default'
  | 'module-scale'
  | 'module'
  | 'safe-area-bottom-all'
  | 'safe-area-bottom'
  | 'safe-area-content-bottom'
  | 'safe-area-content-left'
  | 'safe-area-content-right'
  | 'safe-area-content-top'
  | 'safe-area-left-all'
  | 'safe-area-left'
  | 'safe-area-right-all'
  | 'safe-area-right'
  | 'safe-area-top-all'
  | 'safe-area-top'
  | 'z-index-dropdown'
  | 'z-index-overlay';

export type CSSVariableCamelCase =
  | 'colorAccent'
  | 'colorAccentAct'
  | 'colorAccentAlt'
  | 'colorAccentAltOpacity0'
  | 'colorAccentAltOpacity08'
  | 'colorAccentAltOpacity10'
  | 'colorAccentAltOpacity12'
  | 'colorAccentAltOpacity16'
  | 'colorAccentAltOpacity20'
  | 'colorAccentOpacity0'
  | 'colorAccentOpacity02'
  | 'colorAccentOpacity16'
  | 'colorAccentOpacity20'
  | 'colorAccentOpacity40'
  | 'colorAccentOpacity80'
  | 'colorAccentSplash'
  | 'colorBackgroundModal'
  | 'colorBlackBody'
  | 'colorBlackBody0'
  | 'colorBlackBodyOpacity08'
  | 'colorBlackBodyOpacity25'
  | 'colorBlackDefault'
  | 'colorBlackModal'
  | 'colorBlackModalOpacity08'
  | 'colorBlackModalOpacity09'
  | 'colorBlackModalOpacity60'
  | 'colorDanger'
  | 'colorDangerOpacity0'
  | 'colorDangerOpacity05'
  | 'colorDangerOpacity10'
  | 'colorGreyDark'
  | 'colorGreyDarkOpacity10'
  | 'colorGreyDarkOpacity40'
  | 'colorGreyDarkOpacity50'
  | 'colorGreyDarkOpacity60'
  | 'colorGreyField'
  | 'colorGreyFieldOpacity40'
  | 'colorGreyFieldOpacity50'
  | 'colorGreyLight'
  | 'colorGreyLightOpacity01'
  | 'colorGreyLightOpacity16'
  | 'colorGreyLightOpacity40'
  | 'colorGreyLightOpacity80'
  | 'colorOtherPreview'
  | 'colorSuccess'
  | 'colorSuccessOpacity0'
  | 'colorSuccessOpacity05'
  | 'colorSuccessOpacity10'
  | 'colorSuccessOpacity20'
  | 'colorWhite'
  | 'gradientAccent'
  | 'gradientAccentAlt'
  | 'gradientActiveBadge'
  | 'gradientActivePreview'
  | 'gradientButtonAlternative'
  | 'gradientButtonBase'
  | 'gradientButtonDestructive'
  | 'gradientButtonPrimary'
  | 'gradientButtonSuccess'
  | 'gradientDanger'
  | 'gradientDark'
  | 'gradientInputAccent'
  | 'gradientInputBase'
  | 'gradientInputDanger'
  | 'gradientInputSuccess'
  | 'gradientLoadingOverlay'
  | 'gradientOverlayBadge'
  | 'gradientOverlayCard'
  | 'gradientOverlayPreview'
  | 'gradientSectionActive'
  | 'gradientSectionWaiting'
  | 'gradientStickySplitter'
  | 'gradientSuccess'
  | 'gradientUnreadBadge'
  | 'gradientUnreadPreview'
  | 'gradientWaitingBadge'
  | 'gradientWaitingPreview'
  | 'module'
  | 'module10'
  | 'module11'
  | 'module12'
  | 'module13'
  | 'module14'
  | 'module18'
  | 'module2'
  | 'module3'
  | 'module4'
  | 'module5'
  | 'module6'
  | 'module7'
  | 'module8'
  | 'module9'
  | 'moduleDefault'
  | 'moduleScale'
  | 'safeAreaBottom'
  | 'safeAreaBottomAll'
  | 'safeAreaContentBottom'
  | 'safeAreaContentLeft'
  | 'safeAreaContentRight'
  | 'safeAreaContentTop'
  | 'safeAreaLeft'
  | 'safeAreaLeftAll'
  | 'safeAreaRight'
  | 'safeAreaRightAll'
  | 'safeAreaTop'
  | 'safeAreaTopAll'
  | 'zIndexDropdown'
  | 'zIndexOverlay';

export const CSS_VARIABLE_MAP: Record<CSSVariableCamelCase, CSSVariableName> = {
  colorAccent: 'color-accent',
  colorAccentAct: 'color-accent-act',
  colorAccentAlt: 'color-accent-alt',
  colorAccentAltOpacity0: 'color-accent-alt-opacity-0',
  colorAccentAltOpacity08: 'color-accent-alt-opacity-08',
  colorAccentAltOpacity10: 'color-accent-alt-opacity-10',
  colorAccentAltOpacity12: 'color-accent-alt-opacity-12',
  colorAccentAltOpacity16: 'color-accent-alt-opacity-16',
  colorAccentAltOpacity20: 'color-accent-alt-opacity-20',
  colorAccentOpacity0: 'color-accent-opacity-0',
  colorAccentOpacity02: 'color-accent-opacity-02',
  colorAccentOpacity16: 'color-accent-opacity-16',
  colorAccentOpacity20: 'color-accent-opacity-20',
  colorAccentOpacity40: 'color-accent-opacity-40',
  colorAccentOpacity80: 'color-accent-opacity-80',
  colorAccentSplash: 'color-accent-splash',
  colorBackgroundModal: 'color-background-modal',
  colorBlackBody: 'color-black-body',
  colorBlackBody0: 'color-black-body-0',
  colorBlackBodyOpacity08: 'color-black-body-opacity-08',
  colorBlackBodyOpacity25: 'color-black-body-opacity-25',
  colorBlackDefault: 'color-black-default',
  colorBlackModal: 'color-black-modal',
  colorBlackModalOpacity08: 'color-black-modal-opacity-08',
  colorBlackModalOpacity09: 'color-black-modal-opacity-09',
  colorBlackModalOpacity60: 'color-black-modal-opacity-60',
  colorDanger: 'color-danger',
  colorDangerOpacity0: 'color-danger-opacity-0',
  colorDangerOpacity05: 'color-danger-opacity-05',
  colorDangerOpacity10: 'color-danger-opacity-10',
  colorGreyDark: 'color-grey-dark',
  colorGreyDarkOpacity10: 'color-grey-dark-opacity-10',
  colorGreyDarkOpacity40: 'color-grey-dark-opacity-40',
  colorGreyDarkOpacity50: 'color-grey-dark-opacity-50',
  colorGreyDarkOpacity60: 'color-grey-dark-opacity-60',
  colorGreyField: 'color-grey-field',
  colorGreyFieldOpacity40: 'color-grey-field-opacity-40',
  colorGreyFieldOpacity50: 'color-grey-field-opacity-50',
  colorGreyLight: 'color-grey-light',
  colorGreyLightOpacity01: 'color-grey-light-opacity-01',
  colorGreyLightOpacity16: 'color-grey-light-opacity-16',
  colorGreyLightOpacity40: 'color-grey-light-opacity-40',
  colorGreyLightOpacity80: 'color-grey-light-opacity-80',
  colorOtherPreview: 'color-other-preview',
  colorSuccess: 'color-success',
  colorSuccessOpacity0: 'color-success-opacity-0',
  colorSuccessOpacity05: 'color-success-opacity-05',
  colorSuccessOpacity10: 'color-success-opacity-10',
  colorSuccessOpacity20: 'color-success-opacity-20',
  colorWhite: 'color-white',
  gradientAccent: 'gradient-accent',
  gradientAccentAlt: 'gradient-accent-alt',
  gradientActiveBadge: 'gradient-active-badge',
  gradientActivePreview: 'gradient-active-preview',
  gradientButtonAlternative: 'gradient-button-alternative',
  gradientButtonBase: 'gradient-button-base',
  gradientButtonDestructive: 'gradient-button-destructive',
  gradientButtonPrimary: 'gradient-button-primary',
  gradientButtonSuccess: 'gradient-button-success',
  gradientDanger: 'gradient-danger',
  gradientDark: 'gradient-dark',
  gradientInputAccent: 'gradient-input-accent',
  gradientInputBase: 'gradient-input-base',
  gradientInputDanger: 'gradient-input-danger',
  gradientInputSuccess: 'gradient-input-success',
  gradientLoadingOverlay: 'gradient-loading-overlay',
  gradientOverlayBadge: 'gradient-overlay-badge',
  gradientOverlayCard: 'gradient-overlay-card',
  gradientOverlayPreview: 'gradient-overlay-preview',
  gradientSectionActive: 'gradient-section-active',
  gradientSectionWaiting: 'gradient-section-waiting',
  gradientStickySplitter: 'gradient-sticky-splitter',
  gradientSuccess: 'gradient-success',
  gradientUnreadBadge: 'gradient-unread-badge',
  gradientUnreadPreview: 'gradient-unread-preview',
  gradientWaitingBadge: 'gradient-waiting-badge',
  gradientWaitingPreview: 'gradient-waiting-preview',
  module: 'module',
  module10: 'module-10',
  module11: 'module-11',
  module12: 'module-12',
  module13: 'module-13',
  module14: 'module-14',
  module18: 'module-18',
  module2: 'module-2',
  module3: 'module-3',
  module4: 'module-4',
  module5: 'module-5',
  module6: 'module-6',
  module7: 'module-7',
  module8: 'module-8',
  module9: 'module-9',
  moduleDefault: 'module-default',
  moduleScale: 'module-scale',
  safeAreaBottom: 'safe-area-bottom',
  safeAreaBottomAll: 'safe-area-bottom-all',
  safeAreaContentBottom: 'safe-area-content-bottom',
  safeAreaContentLeft: 'safe-area-content-left',
  safeAreaContentRight: 'safe-area-content-right',
  safeAreaContentTop: 'safe-area-content-top',
  safeAreaLeft: 'safe-area-left',
  safeAreaLeftAll: 'safe-area-left-all',
  safeAreaRight: 'safe-area-right',
  safeAreaRightAll: 'safe-area-right-all',
  safeAreaTop: 'safe-area-top',
  safeAreaTopAll: 'safe-area-top-all',
  zIndexDropdown: 'z-index-dropdown',
  zIndexOverlay: 'z-index-overlay',
};

export const CSS_VARIABLES = {
  colors: {
    colorAccent: '--color-accent',
    colorAccentAct: '--color-accent-act',
    colorAccentAlt: '--color-accent-alt',
    colorAccentAltOpacity0: '--color-accent-alt-opacity-0',
    colorAccentAltOpacity08: '--color-accent-alt-opacity-08',
    colorAccentAltOpacity10: '--color-accent-alt-opacity-10',
    colorAccentAltOpacity12: '--color-accent-alt-opacity-12',
    colorAccentAltOpacity16: '--color-accent-alt-opacity-16',
    colorAccentAltOpacity20: '--color-accent-alt-opacity-20',
    colorAccentOpacity0: '--color-accent-opacity-0',
    colorAccentOpacity02: '--color-accent-opacity-02',
    colorAccentOpacity16: '--color-accent-opacity-16',
    colorAccentOpacity20: '--color-accent-opacity-20',
    colorAccentOpacity40: '--color-accent-opacity-40',
    colorAccentOpacity80: '--color-accent-opacity-80',
    colorAccentSplash: '--color-accent-splash',
    colorBackgroundModal: '--color-background-modal',
    colorBlackBody: '--color-black-body',
    colorBlackBody0: '--color-black-body-0',
    colorBlackBodyOpacity08: '--color-black-body-opacity-08',
    colorBlackBodyOpacity25: '--color-black-body-opacity-25',
    colorBlackDefault: '--color-black-default',
    colorBlackModal: '--color-black-modal',
    colorBlackModalOpacity08: '--color-black-modal-opacity-08',
    colorBlackModalOpacity09: '--color-black-modal-opacity-09',
    colorBlackModalOpacity60: '--color-black-modal-opacity-60',
    colorDanger: '--color-danger',
    colorDangerOpacity0: '--color-danger-opacity-0',
    colorDangerOpacity05: '--color-danger-opacity-05',
    colorDangerOpacity10: '--color-danger-opacity-10',
    colorGreyDark: '--color-grey-dark',
    colorGreyDarkOpacity10: '--color-grey-dark-opacity-10',
    colorGreyDarkOpacity40: '--color-grey-dark-opacity-40',
    colorGreyDarkOpacity50: '--color-grey-dark-opacity-50',
    colorGreyDarkOpacity60: '--color-grey-dark-opacity-60',
    colorGreyField: '--color-grey-field',
    colorGreyFieldOpacity40: '--color-grey-field-opacity-40',
    colorGreyFieldOpacity50: '--color-grey-field-opacity-50',
    colorGreyLight: '--color-grey-light',
    colorGreyLightOpacity01: '--color-grey-light-opacity-01',
    colorGreyLightOpacity16: '--color-grey-light-opacity-16',
    colorGreyLightOpacity40: '--color-grey-light-opacity-40',
    colorGreyLightOpacity80: '--color-grey-light-opacity-80',
    colorOtherPreview: '--color-other-preview',
    colorSuccess: '--color-success',
    colorSuccessOpacity0: '--color-success-opacity-0',
    colorSuccessOpacity05: '--color-success-opacity-05',
    colorSuccessOpacity10: '--color-success-opacity-10',
    colorSuccessOpacity20: '--color-success-opacity-20',
    colorWhite: '--color-white',
  },
  modules: {
    module: '--module',
    module10: '--module-10',
    module11: '--module-11',
    module12: '--module-12',
    module13: '--module-13',
    module14: '--module-14',
    module18: '--module-18',
    module2: '--module-2',
    module3: '--module-3',
    module4: '--module-4',
    module5: '--module-5',
    module6: '--module-6',
    module7: '--module-7',
    module8: '--module-8',
    module9: '--module-9',
    moduleDefault: '--module-default',
    moduleScale: '--module-scale',
  },
  other: {
    gradientAccent: '--gradient-accent',
    gradientAccentAlt: '--gradient-accent-alt',
    gradientActiveBadge: '--gradient-active-badge',
    gradientActivePreview: '--gradient-active-preview',
    gradientButtonAlternative: '--gradient-button-alternative',
    gradientButtonBase: '--gradient-button-base',
    gradientButtonDestructive: '--gradient-button-destructive',
    gradientButtonPrimary: '--gradient-button-primary',
    gradientButtonSuccess: '--gradient-button-success',
    gradientDanger: '--gradient-danger',
    gradientDark: '--gradient-dark',
    gradientInputAccent: '--gradient-input-accent',
    gradientInputBase: '--gradient-input-base',
    gradientInputDanger: '--gradient-input-danger',
    gradientInputSuccess: '--gradient-input-success',
    gradientLoadingOverlay: '--gradient-loading-overlay',
    gradientOverlayBadge: '--gradient-overlay-badge',
    gradientOverlayCard: '--gradient-overlay-card',
    gradientOverlayPreview: '--gradient-overlay-preview',
    gradientSectionActive: '--gradient-section-active',
    gradientSectionWaiting: '--gradient-section-waiting',
    gradientStickySplitter: '--gradient-sticky-splitter',
    gradientSuccess: '--gradient-success',
    gradientUnreadBadge: '--gradient-unread-badge',
    gradientUnreadPreview: '--gradient-unread-preview',
    gradientWaitingBadge: '--gradient-waiting-badge',
    gradientWaitingPreview: '--gradient-waiting-preview',
    zIndexDropdown: '--z-index-dropdown',
    zIndexOverlay: '--z-index-overlay',
  },
  safeArea: {
    safeAreaBottom: '--safe-area-bottom',
    safeAreaBottomAll: '--safe-area-bottom-all',
    safeAreaContentBottom: '--safe-area-content-bottom',
    safeAreaContentLeft: '--safe-area-content-left',
    safeAreaContentRight: '--safe-area-content-right',
    safeAreaContentTop: '--safe-area-content-top',
    safeAreaLeft: '--safe-area-left',
    safeAreaLeftAll: '--safe-area-left-all',
    safeAreaRight: '--safe-area-right',
    safeAreaRightAll: '--safe-area-right-all',
    safeAreaTop: '--safe-area-top',
    safeAreaTopAll: '--safe-area-top-all',
  },
} as const;
